var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.002,
    height: 9.999,
    viewBox: "0 0 10.002 9.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic-sites",
    d: "M-10737,5736a5.007,5.007,0,0,1-5-5,5.005,5.005,0,0,1,5-5,5.005,5.005,0,0,1,5,5A5.007,5.007,0,0,1-10737,5736Zm0-8.57a2.5,2.5,0,0,0-2.5,2.5c0,1.826,2.4,4.527,2.5,4.642.024-.026,2.5-2.777,2.5-4.642A2.5,2.5,0,0,0-10737,5727.429Zm0,3.391a.893.893,0,0,1-.893-.892.894.894,0,0,1,.893-.893.894.894,0,0,1,.893.893A.893.893,0,0,1-10737,5730.82Z",
    transform: "translate(10742.003 -5726)",
    fill: "#ccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSites);
export default __webpack_public_path__ + "static/media/ic-sites.955c165bc74d6addd03cdce32b1e57af.svg";
export { ForwardRef as ReactComponent };